import { render, staticRenderFns } from "./StatusCards.vue?vue&type=template&id=10728480&scoped=true"
import script from "./StatusCards.vue?vue&type=script&lang=js"
export * from "./StatusCards.vue?vue&type=script&lang=js"
import style0 from "./StatusCards.vue?vue&type=style&index=0&id=10728480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10728480",
  null
  
)

export default component.exports